<form [formGroup]="form">
  <app-input-group>
    <label appLabel>{{ 'common.changedate' | translate }}</label>
    <input type="date" formControlName="occurrence" appInput>
  </app-input-group>
</form>
